import React, { useState, useContext, useEffect } from 'react'
import PaginationComponent from '../../../Component/Pagination'
import { Link, useHistory } from 'react-router-dom'
import Bidhistory from '../../../Component/Bidhistory'
import { getFilePath } from '../../../utils/commonFunctions'
import './product.css'
import 'react-confirm-alert/src/react-confirm-alert.css'
import Timer from '../../../Product/common/timer'
import Bidding from '../../../Product/components/molecules/Bidding/BiddingItem'
import AuthContext from '../../../Product/context/auth/authContext'
import GridProduct from '../../../Component/ProductCard/gridProduct'
import MultisellerListCard from '../../../Component/ProductCard/MultisellerListCard'
import { Button } from '@material-ui/core'
import CustomSelect from '../../../Product/components/atoms/Inputs/CustomSelect'
import Facebook from '../../../utils/CommonFunctionality/Share/Facebook'
import Whatsapp from '../../../utils/CommonFunctionality/Share/Whatsapp'
import Twitter from '../../../utils/CommonFunctionality/Share/Twitter'
import Email from '../../../utils/CommonFunctionality/Share/Email'
import Pinterest from '../../../utils/CommonFunctionality/Share/Pinterest'
const SubLotsComponent = (props) => {
    const authContext = useContext(AuthContext)
    const [auctionView, setAuctionView] = useState('Grid')

    const [selectedHistory, setSelectedHistory] = useState({})

    const { user, isAuthenticated } = authContext
    const history = useHistory()

    const openHistory = (property) => {
        setSelectedHistory(property)
    }

    const pageOptions = [
        {
            value: '12',
            show: 'Results 12 per page',
        },
        {
            value: '24',
            show: 'Results 24 per page',
        },
        {
            value: '36',
            show: 'Results 36 per page',
        },
    ]

    return (
        <div className="msSublots" id="sublot">
            <div className="d-flex justify-content-between align-items-center flex-wrap my-5">
                <h2 className="auctionListTitle">Lots</h2>
                <div className="auctionsMiscFilter">
                    <div className="pvMiscActions">
                        <Facebook
                            path={`/search/product-buyer-auction/${props.auctionid}`}
                            title={props.title}
                        />
                        <Whatsapp
                            path={`/search/product-buyer-auction/${props.auctionid}`}
                            title={props.title}
                        />
                        <Twitter
                            path={`/search/product-buyer-auction/${props.auctionid}`}
                            title={props.title}
                        />
                        <Email
                            path={`/search/product-buyer-auction/${props.auctionid}`}
                            subject={props.title}
                            body={props.auctionDesc}
                        />
                        <Pinterest
                            path={`/search/product-buyer-auction/${props.auctionid}`}
                            title={props.title}
                            media={`${
                                props.auctionData.store_id
                                    ? process.env.REACT_APP_PRODUCT_IMAGE_URL
                                    : process.env.REACT_APP_BASE_URL + 'uploads/product/'
                            }${props.auctionData.avatar}`}
                        />
                    </div>
                    <div className="gridListToggle">
                        <Button
                            className={auctionView === 'Grid' ? 'active' : ''}
                            onClick={() => setAuctionView('Grid')}
                        >
                            <span className="material-icons">apps</span>
                        </Button>
                        <Button
                            className={auctionView === 'List' ? 'active' : ''}
                            onClick={() => setAuctionView('List')}
                        >
                            <span className="material-icons">view_list</span>
                        </Button>
                    </div>
                    <CustomSelect
                        label="Results per page"
                        name="resultsPerPage"
                        selectType="noBorder"
                        value={props.subLotSearch.limit}
                        size="small"
                        onChange={(event, editor) => {
                            props.setSubLotSearch({
                                ...props.subLotSearch,
                                limit: event.target.value,
                            })
                        }}
                    >
                        {pageOptions.map((opt, optindex) => (
                            <option value={opt.value}>{opt.show}</option>
                        ))}
                    </CustomSelect>
                </div>
            </div>
            <div className={`lotResults ${auctionView}`}>
                {props.lotData.map((data, index) =>
                    auctionView === 'Grid' ? (
                        <GridProduct
                            data={data}
                            key={index}
                            lotImages={data.lotImages}
                            selectedProduct={props.selectedPostion}
                            link={`/gallery/product-view/${data.id}`}
                            handleClick={props.handleClick}
                            timerTheme="HeavyEquipment"
                            sliderTheme="multiseller"
                            cardTheme="HeavyEquipment"
                            bidBtnLabel="Place Bid"
                            type="buynow"
                            auction_and_buynow={1}
                            noTimer={
                                (data.buynow == 0 && data.auction == 1) || data.auction == 1
                                    ? false
                                    : true
                            }
                        />
                    ) : (
                        <MultisellerListCard
                            lotData={data}
                            key={index}
                            selectedProduct={props.selectedPostion}
                            allsearchitems={props.lotData}
                            type="lot"
                            handleClick={props.handleClick}
                            details={`/gallery/product-view/${data.id}`}
                            sliderTheme="multiseller"
                            bidBtnLabel="Bid"
                            timerTheme=""
                            auction_and_buynow={1}
                        />
                    ),
                )}
            </div>

            <PaginationComponent
                onPageChange={(pageNumber) => {
                    document.getElementById('sublot').scrollIntoView()
                    props.setSubLotSearch({ ...props.subLotSearch, page: pageNumber })
                }}
                totalProductCount={props.subLotDataCount}
                currentPage={props.subLotSearch.page}
                resultToShow={props.subLotSearch.limit}
            />
            <Bidhistory
                modaltitle="Bid history"
                open={Object.keys(selectedHistory).length !== 0}
                value={selectedHistory}
                serverTime={props.serverTimeSocket}
                handleClose={() => openHistory({})}
            />
        </div>
    )
}

export default SubLotsComponent
